(function() {
	'use strict';

	angular.module('quantixApp').factory('PortfolioService', PortfolioService);

	PortfolioService.$inject = [ '$http', '$q' ];
	function PortfolioService($http, $q) {

		var _savePortfolio = function(portfolioData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/addPortfolio';
			$http.post(url, portfolioData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

        var _getIsGenericFeedPortfolioEnabled = function() {
            var deferred = $q.defer();
//            var url = 'http://localhost:9050/quantix/api/isFeedPortfolioScreen';
            var url = '/quantix/api/esgapi/isFeedPortfolioScreen';
            $http.post(url).then(function(response) {
                deferred.resolve(response.data);
            }, function(errResponse) {
                deferred.reject(errResponse);
            });
            return deferred.promise;
        }

		var _saveAxisPortfolio = function(portfolioData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/addAxisPortfolio';
			$http.post(url, portfolioData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		// upload portfolio excel
		var _uploadPortfolio = function(portfolioData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/uploadPortfolioCompanyData';

			var fd = new FormData();
			fd.append('file', portfolioData.fileUpload);
			fd.append('portfolioName', portfolioData.excelPortfolioName);

			$http.post(url, fd, {
				ignoreLoadingBar : true,
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			setTimeout(function() {
				deferred.resolve([ "success" ]);
			}, 3000);
			return deferred.promise;
		}

			var _validateAxisPortfolio = function() {
			var deferred = $q.defer();
			var url = 'api/masterData/checkAxisUserValidity';

			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _uploadAxisBankPortfolio = function(portfolioData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/uploadAxisBankPortfolioCompanyData';

			var fd = new FormData();
			fd.append('file', portfolioData.fileUpload);
			fd.append('portfolioName', portfolioData.excelPortfolioName);

			$http.post(url, fd, {
				ignoreLoadingBar : true,
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			setTimeout(function() {
				deferred.resolve([ "success" ]);
			}, 3000);
			return deferred.promise;
		}

		var _getRatingMovementPotrtfolioUpgradedowngradeCompInfo = function(
				companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getRatingMovementPotrtfolioUpgradedowngradeCompInfo';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRatingMovementPotrtfolioUpgradedowngrad = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getRatingMovementPotrtfolioUpgradedowngrade';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getBottomCompanies = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getTopBottomPerformersCompaniesOfPortfolioButtonPerformer';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getTopBottomCompanies = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getTopBottomPerformersCompaniesOfPortfolio';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRatingOutlookMasterList = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/masterData/getRatingOutlookMasterList';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRatingAgencyMasterList = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getRatingAgencyMasterList';

			$http.post(url, {}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRatingActionMasterList = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/masterData/getRatingActionMasterList';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getRatingScaleMasterList = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/masterData/getRatingScaleMasterList';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _getRatingScaleMasterData = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getRatingScaleMasterData';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _getListingTypeMasterList = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getListingTypeMasterList';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _getRatedAmountMasterList = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getRatedAmountMasterList';

			$http.post(url, {}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getUserPortfolio = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getUserPortfolio';

			$http.post(url, {}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getAllPortfolio = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getAllPortfolio';

			$http.post(url, {}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getLinkedPortfolioDetails = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getLinkedPortfolioDetails';

			$http.post(url, {}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getPendingCalculationPort = function() {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPendingCalculationPort';

			$http.post(url, {}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getSharedPortfolio = function(companyId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getSharedPortfolio';

			$http.post(url, {}, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getPortfolioDetails = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPortfolioDetails';

			$http.post(url, searchText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var getUsersForClient = function(dataText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getUsersForClient';

			$http.post(url, dataText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _sharePortfolio = function(dataText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/sharePortfolio';

			$http.post(url, dataText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _linkPortfilio = function(dataText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/linkPortfolio';

			$http.post(url, dataText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _validatePortfolioName = function(portfolioName, inputValue) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioNameValidation';

			$http.post(url, portfolioName, inputValue).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _validateAxisPortfolioName = function(portfolioName, inputValue) {
			var deferred = $q.defer();
			var url = 'api/portfolio/axisPortfolioNameValidation';

			$http.post(url, portfolioName, inputValue).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _comparePortfolios = function(dataText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/comparePortfolios';

			$http.post(url, dataText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _viewPortfolio = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/viewPortfolio';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _viewNews = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/viewNews';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getViewratingSummary = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getViewratingSummary';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getViewSummaryTable = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getViewSummaryTable';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : false
			}).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getviewOverView = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/viewOverView';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getviewUpdates = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/viewUpdates';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _companyPerformer = function(parameter) {
			var deferred = $q.defer();
			var url = 'api/portfolio/companyPerformer';
			$http.post(url, parameter).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _portfolioAnalysisTab = function(searchData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioAnalysisTab';

			$http.post(url, searchData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _portfolioAnalysisTabForIndustryAndLocation = function(searchData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioAnalysisTabFoIndustryAndLocation';

			$http.post(url, searchData, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _portfolioReturnsAnalysisTab = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioReturnsAnalysisTab';

			$http.post(url, portfolioVO, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getUpgradeDowngradeCountData = function(searchData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getUpgradesDowngradesCountData';

			$http.post(url, searchData, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _portfolioUpdatesTab = function(searchData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioUpdatesTab';

			$http.post(url, searchData, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _portfolioSummaryTab = function(searchData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioSummaryTabFormatted';

			$http.post(url, searchData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _portfolioOverviewTab = function(searchData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioOverviewTab';

			$http.post(url, searchData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getInstrumentDetails = function(instrumentData) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getInstrumentDetails';

			$http.post(url, instrumentData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getPortfolioList = function(inputs) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPortfolioList';
			$http.post(url, inputs).then(function(response) {

				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		var _getUserPortfolioList = function(inputs) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getUserPortfolioList';
			$http.post(url, inputs).then(function(response) {

				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		var _downloadPortfolio = function(portfolioData) {
			// alert(JSON.stringify(portfolioData));
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioexportSpreadJS';
			$http.post(url, portfolioData).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _deletePortfolio = function(dataText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/deletePortfolio';
			$http.post(url, dataText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		var _checkPortfolioAvailablity = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/checkPortfolioAvailablity';
			$http.post(url, portfolioVO).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		var _getRatingSummary = function(portfolioId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getRatingAction';
			$http.post(url, portfolioId).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getLocationInfo = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPortfolioLocationInfo';
			$http.post(url, searchText, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getPortFolioSetAlertFlag = function(portfolioId) {
			var deferred = $q.defer();
			var portData = {
				portfolioId : portfolioId
			};
			var url = 'api/portfolio/getPortFolioSetAlertFlag';
			$http.post(url, portData, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _removePortfolioMappings = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/removePortfolioMappings';
			$http.post(url, portfolioVO).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		var _reCreatePortfolio = function(portfolioVO) {
			var deferred = $q.defer();
			var url = 'api/portfolio/reCreatePortfolio';
			$http.post(url, portfolioVO).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		var _getPortfolioNewsData = function(portfolioVONews) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getPortfolioNewsData';
			$http.post(url, portfolioVONews).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getRatingTransition = function(searchText) {

			var deferred = $q.defer();
			var url = 'api/portfolio/ratingPerformer';

			$http.post(url, searchText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		var _getPortfolioCalculation = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/portfolio/portfolioCalculation';

			$http.post(url, searchText, {
				ignoreLoadingBar : false
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getIndustryClassification = function(searchtext) {
			var deferred = $q.defer();
			var url = 'api/portfolio/classification';

			$http.post(url, searchtext).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _validatePortfolio = function(id) {
			var deferred = $q.defer();
			var url = 'api/portfolio/checkValidity';

			$http.post(url, id).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _validatePortfolioNameEdit = function(portfolioName, inputValue) {
			var deferred = $q.defer();
			var url = 'api/portfolio/validatePortfolioNameEdit';

			$http.post(url, portfolioName, inputValue).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getManuDetailsList = function(inputs) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getManuDetailsList';
			$http.post(url, inputs).then(function(response) {

				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		var _getScoreCardList = function(inputs) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getScoreCardList';
			$http.post(url, inputs).then(function(response) {

				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		var _getBreakupData = function(portfolioId,type) {
			var deferred = $q.defer();
			var config={
				"params": {"portfolioId":portfolioId,"type":type}
			}
			var url = 'api/portfolio/getPortfolioBreakup';
			$http.get(url,config).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}


		var _getOverviewForRange = function(portfolioId,startDate,endDate) {
			var deferred = $q.defer();
			var config={
				"params": {
					"portfolioId":portfolioId,
					'startDate':startDate,
					'endDate':endDate
				}
			}
			var url = 'api/portfolio/getOverviewForRange';
			$http.get(url,config).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}





		return {
			savePortfolio : _savePortfolio,
			saveAxisPortfolio : _saveAxisPortfolio,
			uploadPortfolio : _uploadPortfolio,
			uploadAxisBankPortfolio : _uploadAxisBankPortfolio,
			validateAxisPortfolio : _validateAxisPortfolio,
			getRatingMovementPotrtfolioUpgradedowngradeCompInfo : _getRatingMovementPotrtfolioUpgradedowngradeCompInfo,
			getRatingMovementPotrtfolioUpgradedowngrad : _getRatingMovementPotrtfolioUpgradedowngrad,
			getBottomCompanies : _getBottomCompanies,
			getTopBottomCompanies : _getTopBottomCompanies,
			getRatingOutlookMasterList : _getRatingOutlookMasterList,
			getRatingAgencyMasterList : _getRatingAgencyMasterList,
			getRatingActionMasterList : _getRatingActionMasterList,
			getRatingScaleMasterList : _getRatingScaleMasterList,
			getRatingScaleMasterData : _getRatingScaleMasterData,
			getListingTypeMasterList : _getListingTypeMasterList,
			getRatedAmountMasterList : _getRatedAmountMasterList,
			getUserPortfolio : _getUserPortfolio,
			getPendingCalculationPort : _getPendingCalculationPort,
			getSharedPortfolio : _getSharedPortfolio,
			getAllPortfolio : _getAllPortfolio,
			getLinkedPortfolioDetails : _getLinkedPortfolioDetails,
			getPortfolioDetails : _getPortfolioDetails,
			getUsersForClient : getUsersForClient,
			sharePortfolio : _sharePortfolio,
			linkPortfilio : _linkPortfilio,
			validatePortfolioName : _validatePortfolioName,
			validateAxisPortfolioName : _validateAxisPortfolioName,
			comparePortfolios : _comparePortfolios,
			viewPortfolio : _viewPortfolio,
			viewNews : _viewNews,
			getViewratingSummary : _getViewratingSummary,
			getViewSummaryTable : _getViewSummaryTable,
			getviewOverView : _getviewOverView,
			getviewUpdates : _getviewUpdates,
			companyPerformer : _companyPerformer,
			portfolioAnalysisTab : _portfolioAnalysisTab,
			getUpgradeDowngradeCountData : _getUpgradeDowngradeCountData,
			portfolioUpdatesTab : _portfolioUpdatesTab,
			portfolioSummaryTab : _portfolioSummaryTab,
			portfolioOverviewTab : _portfolioOverviewTab,
			getInstrumentDetails : _getInstrumentDetails,
			getPortfolioList : _getPortfolioList,
			getUserPortfolioList : _getUserPortfolioList,
			downloadPortfolio : _downloadPortfolio,
			deletePortfolio : _deletePortfolio,
			checkPortfolioAvailablity : _checkPortfolioAvailablity,
			getRatingSummary : _getRatingSummary,
			getLocationInfo : _getLocationInfo,
			portfolioAnalysisTabForIndustryAndLocation : _portfolioAnalysisTabForIndustryAndLocation,
			portfolioReturnsAnalysisTab : _portfolioReturnsAnalysisTab,
			getPortFolioSetAlertFlag : _getPortFolioSetAlertFlag,
			removePortfolioMappings : _removePortfolioMappings,
			reCreatePortfolio : _reCreatePortfolio,
			getPortfolioNewsData : _getPortfolioNewsData,
			getPortfolioCalculation : _getPortfolioCalculation,
			getRatingTransition : _getRatingTransition,
			getIndustryClassification : _getIndustryClassification,
			validatePortfolio : _validatePortfolio,
			validatePortfolioNameEdit : _validatePortfolioNameEdit,
			getScoreCardList:_getScoreCardList,
			getManuDetailsList:_getManuDetailsList,
			getBreakupData:_getBreakupData,
			getIsGenericFeedPortfolioEnabled:_getIsGenericFeedPortfolioEnabled,
			getOverviewForRange:_getOverviewForRange
		};
	}
})();
